import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '../../../common/html/icon'
import { FILTER_BY } from '../../constant'
import { changeFilter, selectFilter } from '../store/slice'
import classes from './index.module.scss'

const ListSelect = () => {
  const dispatch = useDispatch()
  const searchCompanyAndPerson = useSelector(
    selectFilter('searchCompanyAndPerson'),
  )

  const handleRemove = (item) => {
    const next = searchCompanyAndPerson.filter(
      (c) =>
        c.type !== item.type ||
        c.personId !== item.personId ||
        c.organizationId !== item.organizationId,
    )
    dispatch(
      changeFilter({
        searchCompanyAndPerson: next,
      }),
    )
  }

  return (
    <div className={classes.selectedList}>
      {searchCompanyAndPerson.map((item) => (
        <SelectItem
          key={item?.personId || item?.organizationId}
          item={item}
          onRemove={() => handleRemove(item)}
        />
      ))}
    </div>
  )
}

export default ListSelect

const SelectItem = ({ item, onRemove }) => {
  return (
    <div className={classes.itemCompany}>
      <span className={classes.itemText}>
        {item.type === FILTER_BY.COMPANY
          ? item?.organizationName
          : item?.fullName}
      </span>
      <Icon
        className="icon-delete-circle-fill"
        onClick={onRemove}
        style={{ color: '#9C9C9C' }}
      />
    </div>
  )
}
